<template>
    <b-container fluid>
        <b-row>
            <b-col cols="12" md="3" lg="2">
                <b-button
                    block
                    @click="
                        $router.push({
                            name: 'clientContactsPage',
                            params: { clientId: clientId }
                        })
                    "
                    variant="primary"
                    ><i class="fa fa-arrow-left" aria-hidden="true"></i
                ></b-button>
            </b-col>
            <b-col>
                <app-sub-title :text="`Reporte de la reunión cliente ${client.name}`" />

            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <app-contact-rerport-form :client-id="clientId" :report="report" :isSave="isSave"></app-contact-rerport-form>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import ContactReportForm from '../ContactReportForm/ContactReportForm';
export default {
    components: {
        appContactRerportForm: ContactReportForm
    },
    props: {
        clientId: {
            required: true
        },
        report: {
            type: Object,
            default: null,
        },
        isSave: {
            type: Boolean,
            default: true
        }
    }
}
</script>